import PropTypes from 'prop-types';

function ColdKeeperIcon({ width }) {
    return (
        <svg
            width={width}
            height={Math.round(width * 1.29)}
            viewBox="0 0 21 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.13909 9.847C1.11035 7.87559 0.960915 5.04771 1.13909 3.27745C1.31726 2.65672 1.36899 1.05315 3.39788 1.02441C5.42677 0.995671 15.1229 0.955438 16.8414 1.02441C18.5599 1.09338 19.5428 1.47272 19.652 3.77175C19.7612 7.22029 19.7727 13.2669 19.652 16.612C19.4796 20.164 19.9623 22.6357 19.652 23.7852C19.3416 24.9347 19 25.9863 15.1229 26.2852C10.7605 26.2852 7.44417 25.9346 5.6222 25.9863C3.80022 26.0381 1.1391 26.2852 1.06438 23.9172C0.868966 21.0607 1.18507 12.5426 1.13909 9.847Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.862135"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.77665 14.5004C7.77665 11.0519 7.77665 7.79292 7.77665 6.74111C7.86861 5.01684 7.43179 3.37304 9.46643 3.29257C11.5011 3.21211 11.9954 3.78686 12.0643 5.39618C12.1103 6.45374 12.0069 10.3392 11.9839 14.2475L7.77665 14.5004Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.862135"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7.79374 6.75278H9.90309H7.79374Z" fill="white" />
            <path
                d="M7.79374 6.75278H9.90309"
                stroke="#2D2D2D"
                strokeWidth="0.862135"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.86857 10.6725H9.39167"
                stroke="#2D2D2D"
                strokeWidth="0.862135"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.79953 16.7824V13.5005L12 13.2852C12 13.2852 12.0642 15.8973 12.1102 16.7824C12.7367 17.2479 14.6909 18.9607 13.7885 21.3345C12.8861 23.7082 10.5813 24.2082 8.65017 23.6335C7.84304 23.3657 7.14664 22.8394 6.66872 22.1361C6.19079 21.4327 5.95797 20.5914 6.00629 19.7424C6.00629 19.7424 6.13273 17.6158 7.79953 16.7824Z"
                className="fill-[#B0C372] if:fill-[#E95CA2]"
                stroke="#2D2D2D"
                strokeWidth="0.862135"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ColdKeeperIcon;

ColdKeeperIcon.propTypes = {
    width: PropTypes.number,
};

ColdKeeperIcon.defaultProps = {
    width: 19,
};
